export const DELETE_TOURNAMENT_API = 'v1/tournaments';

export const getDeleteTournamentEndpoint = (tournamentId: string) =>
  `${DELETE_TOURNAMENT_API}/${tournamentId}/delete`;
